<template>
  <div class="back_page" @click="back">
    <div class="back"><i class="icon" v-if="!hidBack"></i></div>
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  name: 'back',
  props: {
    title: String,
    backPage: Object,
    hidBack: Boolean
  },
  methods: {
    back() {
      this.$parent.handleBack()
    }
  }
}
</script>